'use client'

import { useSignals } from '@preact/signals-react/runtime'
import { useClientNav } from '@susu/headless-commerce/features/navigation/components/ClientNavProvider'
import classNames from 'classnames'
import type { ReactNode } from 'react'
import navSubmenuStyles from '../NavSubmenu/NavSubmenu.module.scss'

export type ClientNavSearchPanelProps = {
  children: ReactNode
  className?: string
}

export const ClientNavSearchPanel = ({
  children,
  className,
}: ClientNavSearchPanelProps) => {
  useSignals()

  const { isSearchMenuOpened } = useClientNav()

  const searchPanelClass = classNames(
    'nav__search-panel',
    navSubmenuStyles['nav__submenu'],
    'nav__submenu',
    {
      [`${navSubmenuStyles['nav__submenu--opened']} nav__submenu--opened`]:
        isSearchMenuOpened.value,
    },
    className,
  )

  return (
    <div className={searchPanelClass} data-testid="nav-search-panel">
      {children}
    </div>
  )
}
